import Vue from "vue";
import Child from "./Child";
import VButton from "./VButton";
import CheckBox from "./CheckBox";

[Child, VButton, CheckBox].forEach(component => {
    Vue.component(component.name, component);
});
